import type { ReactNode } from 'react';

import { Illustration } from '@mint-lib/illustrations';

import { Typography } from '@myn/mui';

type Props = {
  header: ReactNode;
  message: ReactNode;
};

const NoData = ({ header, message }: Props) => {
  return (
    <div className="flex h-[calc(100vh-350px)] flex-col items-center justify-center">
      <div className="flex flex-col items-center">
        <Illustration className="size-40" component="IllustrationNoResults" />

        <div>
          <Typography variant="h4">{header}</Typography>
        </div>
        <div className="overflow-hidden break-words">
          <Typography
            variant="bodyShort01"
            color={(theme) => theme.palette.text.secondary}
          >
            {message}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default NoData;
